import React, { useEffect, useState } from 'react';
export var CooldownTimer = function (_a) {
    var cooldownInterval = _a.cooldownInterval;
    var _b = useState(), seconds = _b[0], setSeconds = _b[1];
    useEffect(function () {
        var countdownTimeout;
        if (typeof seconds === 'number' && seconds > 0) {
            countdownTimeout = setTimeout(function () {
                setSeconds(seconds - 1);
            }, 1000);
        }
        return function () {
            clearTimeout(countdownTimeout);
        };
    }, [seconds]);
    useEffect(function () {
        setSeconds(cooldownInterval !== null && cooldownInterval !== void 0 ? cooldownInterval : 0);
    }, [cooldownInterval]);
    return (React.createElement("div", { className: 'str-chat__message-input-cooldown', "data-testid": 'cooldown-timer' }, seconds));
};
